import { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import heroImage from "@/assets/hero-maritime.jpg";

const Hero = () => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!imgRef.current) return;
      imgRef.current.style.transform = `translateY(${window.scrollY * 0.28}px)`;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section
      id="inicio"
      className="min-h-screen relative flex items-center overflow-hidden"
      style={{ background: "var(--color-preto-marca)" }}
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          ref={imgRef}
          src={heroImage}
          alt="Porto marítimo moderno"
          className="w-full h-full object-cover opacity-35"
          style={{ willChange: "transform" }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(10,10,10,0.75) 0%, rgba(10,10,10,0.45) 50%, rgba(10,10,10,0.95) 100%)",
          }}
        />
      </div>

      {/* Grid pattern */}
      <div className="absolute inset-0 z-[1] bg-grid pointer-events-none opacity-60" />

      {/* Bottom fade — vem ANTES do conteúdo no DOM: sem z-index, o conteúdo posterior fica naturalmente por cima */}
      <div
        className="absolute bottom-0 left-0 w-full h-20 pointer-events-none"
        style={{
          background: "linear-gradient(to top, var(--color-branco-vela), transparent)",
        }}
      />

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-6 relative z-10 pt-24 pb-24">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="eyebrow hero-animate-1" style={{ color: "var(--color-cinza-ancora)" }}>
            Especialistas em Ressarcimento AFRMM
          </div>

          {/* Headline */}
          <h1
            className="heading-h1 hero-animate-2 mb-6"
            style={{ color: "var(--color-branco-vela)" }}
          >
            Obtenha o AFRMM com tecnologia e expertise.
          </h1>

          {/* Subtitle */}
          <p
            className="text-lg font-light leading-relaxed max-w-[540px] mb-10 hero-animate-3"
            style={{ color: "var(--color-cinza-nevoa)" }}
          >
            Conhecemos cada etapa, cada trava e cada exigência do processo. E
            construímos a tecnologia para resolver tudo isso em minutos, não em
            dias.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-14 hero-animate-4">
            <a href="#contato" className="btn-cta-dark">
              Análise Gratuita
            </a>
            <a
              href="#como-funciona"
              className="inline-flex items-center gap-2 px-8 py-3 font-medium text-sm transition-colors duration-200 cursor-pointer"
              style={{ color: "var(--color-cinza-nevoa)" }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLElement).style.color = "var(--color-branco-vela)")
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLElement).style.color = "var(--color-cinza-nevoa)")
              }
            >
              Ver Como Funciona <ArrowRight size={16} />
            </a>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-px hero-animate-5">
            {[
              { value: "min", label: "Tempo de processamento", sub: "antes levava 1 dia inteiro" },
              { value: "6+", label: "Empresas atendidas", sub: "" },
              { value: "100%", label: "Processo digital", sub: "rastreável do início ao fim" },
            ].map((stat, i) => (
              <div
                key={i}
                className="px-6 py-5 flex-1 min-w-[140px]"
                style={{
                  border: "1px solid rgba(242, 240, 236, 0.08)",
                  background: "rgba(242, 240, 236, 0.03)",
                  borderRadius: "6px",
                  borderTop: "1px solid var(--color-dourado)",
                }}
              >
                <div
                  className="font-black text-3xl md:text-4xl tracking-tight leading-none mb-1"
                  style={{ color: "var(--color-branco-vela)" }}
                >
                  {stat.value}
                </div>
                <div
                  className="text-sm font-medium"
                  style={{ color: "var(--color-cinza-nevoa)" }}
                >
                  {stat.label}
                </div>
                {stat.sub && (
                  <div
                    className="text-xs mt-0.5 font-light"
                    style={{ color: "var(--color-cinza-ancora)" }}
                  >
                    {stat.sub}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default Hero;
